import React, { memo } from 'react'
import { useState } from 'react'
import styled from 'styled-components'
import HiddenSSR from '../../atoms/HiddenSSR/HiddenSSR'
import ConditionsMegaMenu from './ConditionsMegaMenu'
import TreatmentsMegaMenu from './TreatmentMegaMenu'
import ClienteleMegaMenu from './ClienteleMegaMenu'
import { ChevronRight } from 'react-bootstrap-icons'
import { TREATMENT_PANEL_LINKS } from '../../../domain/megaMenu/constants'

const Style = styled.div`
  width: 100vw;
  justify-content: center;
  display: flex;
  background: #f6f8f9;
  position: absolute;
  top: 70px;
  left: 0;
  z-index: 301;
  .left-sidebar {
    height: inherit;
    display: flex;
    flex-direction: column;
    min-width: 260px;
    height: inherit;
    background: #f6f8f9;
    padding: 40px 0px 16px 0px;
  }
  .container {
    padding: 24px 24px 24px 34px;
    display: flex;
    background: white;
    width: 100%;
    min-height: 600px;
  }

  .header {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 25px;
    display: flex;
    align-items: center;
    color: #4d657f;
    padding-left: 16px;
  }
`

const linksNav = TREATMENT_PANEL_LINKS

export const Link = ({ selected, setSelected, linkData }) => {
  return (
    <React.Fragment>
      <div
        className={`flex h-14 w-full cursor-pointer items-center justify-between px-4 ${
          selected === linkData.name
            ? 'bg-white font-semibold text-gray-1100'
            : ''
        }`}
        onClick={() => {
          setSelected(linkData.name)
        }}
        onMouseEnter={() => {
          setSelected(linkData.name)
        }}
      >
        {linkData.name}
        <ChevronRight className="ml-4 h-4 w-3" />
      </div>
    </React.Fragment>
  )
}

const TreatmentPanel = () => {
  const [selected, setSelected] = useState('Conditions')
  return (
    <Style className="rounded-b-2xl shadow-lg">
      <div style={{ display: 'flex', width: 'inherit', maxWidth: '1600px' }}>
        <div className="left-sidebar">
          <div style={{ height: '40px', width: '100%' }}>
            <p className="header">Find Treatment By</p>
          </div>
          <div>
            {linksNav.map((link) => (
              <Link
                selected={selected}
                linkData={link}
                setSelected={setSelected}
                key={link.name}
              />
            ))}
          </div>
        </div>
        <div className="container">
          <HiddenSSR visible={selected === 'Conditions'}>
            <ConditionsMegaMenu
              linkData={linksNav.filter((nav) => nav.name === 'Conditions')[0]}
            />
          </HiddenSSR>
          <HiddenSSR visible={selected === 'Treatment Methods'}>
            <TreatmentsMegaMenu
              linkData={
                linksNav.filter((nav) => nav.name === 'Treatment Methods')[0]
              }
            />
          </HiddenSSR>
          <HiddenSSR visible={selected === 'Clientele'}>
            <ClienteleMegaMenu
              linkData={linksNav.filter((nav) => nav.name === 'Clientele')[0]}
            />
          </HiddenSSR>
        </div>
      </div>
    </Style>
  )
}

export default memo(TreatmentPanel)
